<template>
	
<div class="chart" >

	<div class="chart-title" v-if="title">{{ title }}<small>10 year fracture probability</small></div>

	<div class="chart-graph">

		<div class="chart-graph-bar" v-for="(age, key) in ages" :key="key"><span :style="{height: ((100 / max) * age[type]) + '%'}"></span></div>

		<div class="chart-graph-y">
			<div v-for="index in Math.ceil(max / 5)" :key="index">{{ index * 5 }}</div>
		</div>

		<div class="chart-graph-x">
			<div>40</div>
			<div>45</div>
			<div>50</div>
			<div>55</div>
			<div>60</div>
			<div>65</div>
			<div>70</div>
			<div>75</div>
			<div>80</div>
			<div>85</div>
			<div>90</div>
		</div>

		<div class="chart-graph-patient" :style="patientStyle"></div>
		
	</div>

	<div class="chart-subtitle">Age (Years)</div>

</div>

</template>

<script>

import rawAges from './age'

export default {
	
	props: ['title', 'max', 'type'],

	computed: {

		score: function() {

			return this.frax((this.type === 'm') ? 'major' : 'hip')

		},

		patientStyle: function() {

			var age = this.$store.getters['logic/variable'](this.$store.getters['logic/variable/named']['age'])

			console.log(this.score, age)

			var left = (age - 40) * 6

			var bottom = (100 / this.max) * this.score

			return {
				left: left + 'px',
				bottom: bottom + '%'
			}

		},

		ages: function() {

			return rawAges

		}

	}
	
}

</script>

<style scoped>

.chart {
	display: flex;
	flex-direction: column;
	width: 300px;
}

.chart-title {
	color: #343434;
	font-size: 16px;
	margin-bottom: 16px;
	text-align: center;
	font-weight: 600;
}

.chart-title small {
	display: block;
	margin-top: 4px;
}

.chart-subtitle {
	color: #343434;
	font-size: 16px;
	margin-bottom: 16px;
	margin-top: 32px;
	text-align: center;
	font-weight: 600;
}

.chart-graph {
	display: flex;
	flex-direction: row;
	width: 300px;
	height: 300px;
}

.chart-graph-bar {
	width: 6px;
	display: flex;
	flex-direction: column;
	justify-content: flex-end;
	height: 300px;
	background-color: #ED7161;
}

.chart-graph-bar span {
	display: block;
	width: 6px;
	background-color: #F8A533;
}

.chart-graph-y {
	width: 16px;
	height: 300px;
	position: absolute;
	top: 0px;
	left: -20px;
	display: flex;
	flex-direction: column-reverse;
}

.chart-graph-y div {
	transform: translateY(-6px);
	font-size: 12px;
	line-height: 12px;
	font-weight: 600;
	color: #343434;
	text-align: center;
	flex-grow: 1;
	flex-shrink: 0;
}

.chart-graph-x {
	width: 300px;
	position: absolute;
	bottom: -16px;
	left: 0px;
	height: 16px;
}

.chart-graph-x div {
	position: absolute;
	top: 0px;
	font-size: 12px;
	line-height: 20px;
	font-weight: 600;
	color: #343434;
	transform: translateX(-50%);
}

.chart-graph-x div:nth-child(1) { left: 0px; }
.chart-graph-x div:nth-child(2) { left: 30px; }
.chart-graph-x div:nth-child(3) { left: 60px; }
.chart-graph-x div:nth-child(4) { left: 90px; }
.chart-graph-x div:nth-child(5) { left: 120px; }
.chart-graph-x div:nth-child(6) { left: 150px; }
.chart-graph-x div:nth-child(7) { left: 180px; }
.chart-graph-x div:nth-child(8) { left: 210px; }
.chart-graph-x div:nth-child(9) { left: 240px; }
.chart-graph-x div:nth-child(10) { left: 270px; }
.chart-graph-x div:nth-child(11) { left: 300px; }

.chart-graph-patient{
	position: absolute;
	background-size: 11px 11px;
	background-image: url(~@/assets/aid/risk/risk/x.svg);
	width: 11px;
	height: 11px;
	margin-left: -9px;
	margin-top: -6px;
}


</style>